/* tslint:disable */

declare var Object: any;
export interface JobGradeServicesInterface {
  "id"?: number;
}

export class JobGradeServices implements JobGradeServicesInterface {
  "id": number;
  constructor(data?: JobGradeServicesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobGradeServices`.
   */
  public static getModelName() {
    return "JobGradeServices";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobGradeServices for dynamic purposes.
  **/
  public static factory(data: JobGradeServicesInterface): JobGradeServices{
    return new JobGradeServices(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobGradeServices',
      plural: 'JobGradeServices',
      path: 'JobGradeServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/JobGradeServices.ts